import React from 'react'
import { BreachEvent } from '@news-mono/web-common'
import { MessageBanner } from '../../../../../banners/MessageBanner/MessageBanner'
import BreachWallContent from './BreachWallContent/BreachWallContent'
import { SimpleTextBanner } from '../../../../../banners/SimpleTextBanner/SimpleTextBanner'
import { TextLink } from '../../../../../typography/TextLink/TextLink'

export interface BreachNotificationProps {
    breachCreativeName: string
    breachDeal: string
    articleId: string | undefined
    onEvent: (event: BreachEvent) => void
}

export function BreachNotification({
    articleId,
    breachDeal,
    breachCreativeName,
    onEvent,
}: BreachNotificationProps) {
    return (
        <div data-testid="BreachScreen">
            <MessageBanner
                icon="subscriber"
                connector="solid-arrow"
                onEvent={onEvent}
            >
                <p>
                    This article is available to subscribers who have digital
                    access included in their subscription.
                </p>
            </MessageBanner>

            <BreachWallContent
                breachDeal={breachDeal}
                articleId={articleId}
                breachCreativeName={breachCreativeName}
                onEvent={onEvent}
                title="Subscribe today."
                message={
                    <p>
                        Get unlimited access to award-winning journalism from
                        Western Australia's biggest newsroom with your
                        subscription.
                    </p>
                }
                cta="View all Packages"
                subscriptionPackages={[
                    {
                        articleId: articleId,
                        breachCreativeName: breachCreativeName,
                        breachDeal: breachDeal,
                        onEvent: onEvent,
                        packagePath: 'subscribe/new',
                        pretitle: 'Digital',
                        heading: 'Everyday Digital',
                        price: '$1 per day',
                        packageType: 'digital',
                    },
                    {
                        articleId: articleId,
                        breachCreativeName: breachCreativeName,
                        breachDeal: breachDeal,
                        onEvent: onEvent,
                        ribbonTitle: 'Most popular',
                        pretitle: 'Digital & Print',
                        heading: 'Weekend Papers + Everyday Digital',
                        price: '$9 per week',
                        packagePath: 'subscribenow/sat-sun+digital',
                        packageType: 'digitalprint',
                    },
                ]}
            />

            <SimpleTextBanner>
                <p>
                    All subscriptions include exclusive subscriber offers,
                    events and giveaways with West Rewards, our subscriber
                    rewards program.
                </p>
                <p>
                    Need Help?{' '}
                    <TextLink href="tel:1800 811 855">1800 811 855</TextLink>.
                </p>
            </SimpleTextBanner>
        </div>
    )
}
